import styled from 'styled-components'

export const Div = styled.div`
  position: fixed;
  width: 3.125em;
  height: 3em;
  top: 0.6em;
  left: ${props => (props.closed ? '25em' : '28.125em')};
  z-index: 100;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: white;
  -webkit-box-shadow: 0px 0px 0.688em 0.125em rgba(0, 0, 0, 0.38);
  box-shadow: 0px 0px 0.688em 0.125em rgba(0, 0, 0, 0.38);
  cursor: pointer;
  border-radius: 0px 5px 5px 0px;
  background-color: ${props => (props.closed ? props.theme : 'white')};
`



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/styles/CloseSearchContent.js